import { t } from 'src/core/utils/i18n';

class Translations {
	private static readonly keys = {
		// App
		app_name: 'app_name',
		// App update dialog
		update: 'update',
		update_later: 'update_later',
		update_available: 'update_available',
		update_available_description: 'update_available_description',
		update_available_mandatory: 'update_available_mandatory',
		update_available_mandatory_description: 'update_available_mandatory_description',
		update_available_version_text: 'update_available_version_text',
		// Archive
		archive_default_title: 'archive_default_title',
		archive_empty_message: 'archive_empty_message',
		archive_search_placeholder: 'archive_search_placeholder',
		archive_recent_events: 'archive_recent_events',
		archive_other_events: 'archive_other_events',
		// Messages
		message_default_title: 'message_default_title',
		message_empty_message: 'message_empty_message',
		message_web_only_title: 'message_web_only_title',
		message_web_only_message: 'message_web_only_message',
		qr_web_only_title: 'qr_web_only_title',
		qr_web_only_message: 'qr_web_only_message',
		message_search_placeholder: 'message_search_placeholder',
		message_no_results_title: 'message_no_results_title',
		message_no_results: 'message_no_results',
		// Errors
		error_default_subject: 'error_default_subject',
		error_default_message: 'error_default_message',
		error_try_again: 'error_try_again',
		error_fetch_event: 'error_fetch_event',
		error_save_event: 'error_save_event',
		error_delete_event: 'error_delete_event',
		error_add_event: 'error_add_event',
		error_event_in_list: 'error_event_in_list',
		error_empty_email_subject: 'error_empty_email_subject',
		error_empty_email_message: 'error_empty_email_message',
		error_user_not_found_subject: 'error_user_not_found_subject',
		error_user_not_found_message: 'error_user_not_found_message',
		error_invalid_credentials: 'error_invalid_credentials',
		error_camera_permission: 'error_camera_permission',
		error_camera_roll_permission_ios: 'error_camera_roll_permission_ios',
		error_camera_roll_permission_android: 'error_camera_roll_permission_android',
		error_delete_event_offline: 'error_delete_event_offline',
		error_add_event_offline: 'error_add_event_offline',
		error_add_event_failed: 'error_add_event_failed',
		error_event_not_found_title: 'error_event_not_found_title',
		error_event_not_found_message: 'error_event_not_found_message',
		error_favorite_toggle_failed: 'error_favorite_toggle_failed',
		error_favorites_load_failed: 'error_favorites_load_failed',
		error_favorites_unavailable_title: 'error_favorites_unavailable_title',
		error_favorites_refresh: 'error_favorites_refresh',
		error_empty_event_code: 'error_empty_event_code',
		error_something_went_wrong: 'error_something_went_wrong',
		error_try_again_later: 'error_try_again_later',
		cancel_deadline_passed_title: 'cancel_deadline_passed_title',
		cancel_deadline_passed_message: 'cancel_deadline_passed_message',
		error_something_went_wrong_short: 'error_something_went_wrong_short',
		error_something_went_wrong_generic: 'error_something_went_wrong_generic',
		notice_session_not_stored_title: 'notice_session_not_stored_title',
		notice_session_not_stored_embedded: 'notice_session_not_stored_embedded',
		notice_session_not_stored: 'notice_session_not_stored',
		error_session_expired_title: 'error_session_expired_title',
		error_session_expired: 'error_session_expired',
		error_no_connection: 'error_no_connection',
		error_server: 'error_server',
		error_went_wrong_title: 'error_went_wrong_title',
		error_return_to_home: 'error_return_to_home',
		error_password_too_short_title: 'error_password_too_short_title',
		error_password_too_short_message: 'error_password_too_short_message',
		error_passwords_not_matching_title: 'error_passwords_not_matching_title',
		error_passwords_not_matching_message: 'error_passwords_not_matching_message',
		error_passwords_not_matching_inline: 'error_passwords_not_matching_inline',
		error_invalid_email_inline: 'error_invalid_email_inline',
		error_feedback_missing_title: 'error_feedback_missing_title',
		error_feedback_missing_message: 'error_feedback_missing_message',
		error_empty_form: 'error_empty_form',
		error_required_fields: 'error_required_fields',
		error_fill_field_above: 'error_fill_field_above',
		error_field_required: 'error_field_required',
		error_event_full_title: 'error_event_full_title',
		error_event_full_message: 'error_event_full_message',
		error_form_closed_title: 'error_form_closed_title',
		error_form_closed_message: 'error_form_closed_message',
		error_form_contact_note: 'error_form_contact_note',
		error_form_login_required: 'error_form_login_required',
		error_form_needs_connection: 'error_form_needs_connection',
		error_form_load_failed: 'error_form_load_failed',
		error_login_required_for_event: 'error_login_required_for_event',
		error_email_exists_title: 'error_email_exists_title',
		error_email_exists_message: 'error_email_exists_message',
		error_fetch_gallery: 'error_fetch_gallery',
		error_photo_permission_title: 'error_photo_permission_title',
		error_photo_permission_message: 'error_photo_permission_message',
		error_camera_not_available_title: 'error_camera_not_available_title',
		error_camera_not_available_message: 'error_camera_not_available_message',
		error_image_load: 'error_image_load',
		error_link_open_title: 'error_link_open_title',
		error_link_open_message: 'error_link_open_message',
		error_open_phone_title: 'error_open_phone_title',
		error_open_email_title: 'error_open_email_title',
		error_open_link_title: 'error_open_link_title',
		error_open_value_message: 'error_open_value_message',
		// Success
		success_saved_subject: 'success_saved_subject',
		success_photo_saved: 'success_photo_saved',
		success_register_subject: 'success_register_subject',
		success_register_message: 'success_register_message',
		success_login_subject: 'success_login_subject',
		success_login_message: 'success_login_message',
		success_welcome_default: 'success_welcome_default',
		success_welcome_named: 'success_welcome_named',
		success_edit_profile_subject: 'success_edit_profile_subject',
		success_edit_profile_message: 'success_edit_profile_message',
		success_password_reset_subject: 'success_password_reset_subject',
		success_password_reset_message: 'success_password_reset_message',
		success_password_forgot_subject: 'success_password_forgot_subject',
		success_password_forgot_message: 'success_password_forgot_message',
		success_uploaded_title: 'success_uploaded_title',
		success_uploaded_message: 'success_uploaded_message',
		success_feedback_title: 'success_feedback_title',
		success_feedback_message: 'success_feedback_message',
		success_form_received_title: 'success_form_received_title',
		success_form_received_message: 'success_form_received_message',
		success_unsubscribed_title: 'success_unsubscribed_title',
		success_unsubscribed_message: 'success_unsubscribed_message',
		success_password_changed: 'success_password_changed',
		success_downloaded_title: 'success_downloaded_title',
		success_downloaded_message_ios: 'success_downloaded_message_ios',
		success_downloaded_message_android: 'success_downloaded_message_android',
		success_downloaded_message_web: 'success_downloaded_message_web',
		// Labels
		label_first_name: 'label_first_name',
		label_last_name: 'label_last_name',
		label_email: 'label_email',
		label_email_android: 'label_email_android',
		label_password: 'label_password',
		label_password_repeat: 'label_password_repeat',
		label_new_password: 'label_new_password',
		label_new_password_repeat: 'label_new_password_repeat',
		label_your_name: 'label_your_name',
		label_the_feedback: 'label_the_feedback',
		label_video_player: 'label_video_player',
		label_map: 'label_map',
		// Placeholders
		placeholder_first_name: 'placeholder_first_name',
		placeholder_first_name_short: 'placeholder_first_name_short',
		placeholder_last_name: 'placeholder_last_name',
		placeholder_last_name_short: 'placeholder_last_name_short',
		placeholder_email: 'placeholder_email',
		placeholder_email_short: 'placeholder_email_short',
		placeholder_email_android: 'placeholder_email_android',
		placeholder_password: 'placeholder_password',
		placeholder_password_min_chars: 'placeholder_password_min_chars',
		placeholder_password_repeat: 'placeholder_password_repeat',
		placeholder_password_short: 'placeholder_password_short',
		placeholder_password_repeat_short: 'placeholder_password_repeat_short',
		placeholder_your_name: 'placeholder_your_name',
		placeholder_feedback: 'placeholder_feedback',
		placeholder_feedback_short: 'placeholder_feedback_short',
		placeholder_choose_option: 'placeholder_choose_option',
		placeholder_search: 'placeholder_search',
		placeholder_event_code: 'placeholder_event_code',
		// Buttons
		button_login: 'button_login',
		button_register: 'button_register',
		button_register_lower: 'button_register_lower',
		button_save: 'button_save',
		button_submit: 'button_submit',
		button_change_password: 'button_change_password',
		button_forgot_password: 'button_forgot_password',
		button_maybe_later: 'button_maybe_later',
		button_send_email: 'button_send_email',
		button_cancel: 'button_cancel',
		button_continue: 'button_continue',
		button_open: 'button_open',
		button_view_program_part: 'button_view_program_part',
		label_choice_info: 'label_choice_info',
		button_favorite: 'button_favorite',
		button_program_view_list: 'button_program_view_list',
		button_program_view_blocks: 'button_program_view_blocks',
		text_choice_full: 'text_choice_full',
		text_seats_left: 'text_seats_left',
		text_choice_not_possible: 'text_choice_not_possible',
		text_max_choices: 'text_max_choices',
		text_day_full: 'text_day_full',
		text_overlaps: 'text_overlaps',
		error_too_many_attempts: 'error_too_many_attempts',
		text_participants_of: 'text_participants_of',
		maps_open_title: 'maps_open_title',
		maps_open_message: 'maps_open_message',
		maps_choose_message: 'maps_choose_message',
		button_ok: 'button_ok',
		button_oke: 'button_oke',
		button_copy: 'button_copy',
		button_save_changes: 'button_save_changes',
		button_submit_upper: 'button_submit_upper',
		button_cancel_upper: 'button_cancel_upper',
		button_add_upper: 'button_add_upper',
		button_navigate_location_upper: 'button_navigate_location_upper',
		button_add: 'button_add',
		button_delete_upper: 'button_delete_upper',
		button_cancel_delete_upper: 'button_cancel_delete_upper',
		button_delete: 'button_delete',
		button_close: 'button_close',
		button_edit: 'button_edit',
		button_done: 'button_done',
		title_subscribe: 'title_subscribe',
		// Tabs
		tab_home: 'tab_home',
		tab_archive: 'tab_archive',
		tab_messages: 'tab_messages',
		tab_photos: 'tab_photos',
		tab_settings: 'tab_settings',
		// Page titles
		title_settings: 'title_settings',
		title_login_or_register: 'title_login_or_register',
		title_welcome: 'title_welcome',
		title_feedback: 'title_feedback',
		title_contact: 'title_contact',
		title_profile: 'title_profile',
		title_edit_profile: 'title_edit_profile',
		title_forgot_password: 'title_forgot_password',
		title_change_password: 'title_change_password',
		title_register: 'title_register',
		title_qr_scanner: 'title_qr_scanner',
		title_photos: 'title_photos',
		title_form_closed: 'title_form_closed',
		title_my_timetable: 'title_my_timetable',
		title_my_submission: 'title_my_submission',
		title_programs: 'title_programs',
		title_day_number: 'title_day_number',
		// Texts
		text_login_description: 'text_login_description',
		text_change_password_description: 'text_change_password_description',
		text_email_not_editable: 'text_email_not_editable',
		text_email_from_account: 'text_email_from_account',
		text_no_internet: 'text_no_internet',
		text_scan_qr_instruction: 'text_scan_qr_instruction',
		text_form_login_description: 'text_form_login_description',
		text_forgot_password_description: 'text_forgot_password_description',
		text_home_has_events: 'text_home_has_events',
		text_home_no_events: 'text_home_no_events',
		text_add_event: 'text_add_event',
		text_no_photos_title: 'text_no_photos_title',
		text_no_photos_message: 'text_no_photos_message',
		text_gallery_empty: 'text_gallery_empty',
		text_feedback_helper: 'text_feedback_helper',
		text_profile_subtitle: 'text_profile_subtitle',
		text_receive_notifications: 'text_receive_notifications',
		text_receive_notifications_helper: 'text_receive_notifications_helper',
		text_give_feedback: 'text_give_feedback',
		text_version_number: 'text_version_number',
		text_privacy_policy: 'text_privacy_policy',
		url_privacy_policy: 'url_privacy_policy',
		url_topicus: 'url_topicus',
		text_contact_topicus: 'text_contact_topicus',
		text_contact_address: 'text_contact_address',
		text_contact_postal: 'text_contact_postal',
		text_set_profile_photo: 'text_set_profile_photo',
		text_choose_profile_photo: 'text_choose_profile_photo',
		text_upload_photo: 'text_upload_photo',
		text_galleries: 'text_galleries',
		text_hindered_question: 'text_hindered_question',
		text_unsubscribe: 'text_unsubscribe',
		text_delete_account: 'text_delete_account',
		// Alerts
		alert_access_event_title: 'alert_access_event_title',
		alert_access_event_message: 'alert_access_event_message',
		alert_login_required_title: 'alert_login_required_title',
		alert_login_required_message: 'alert_login_required_message',
		alert_login_required_view_message: 'alert_login_required_view_message',
		alert_event_already_added_title: 'alert_event_already_added_title',
		alert_scan_qr: 'alert_scan_qr',
		alert_enter_code: 'alert_enter_code',
		alert_event_code_title: 'alert_event_code_title',
		alert_event_code_message: 'alert_event_code_message',
		alert_add_event_title: 'alert_add_event_title',
		alert_add_event_description: 'alert_add_event_description',
		alert_add_event_confirm_message: 'alert_add_event_confirm_message',
		alert_add_photo_title: 'alert_add_photo_title',
		alert_add_photo_message: 'alert_add_photo_message',
		alert_open_camera: 'alert_open_camera',
		alert_open_camera_roll: 'alert_open_camera_roll',
		alert_logout_title: 'alert_logout_title',
		alert_logout_message: 'alert_logout_message',
		alert_logged_out_title: 'alert_logged_out_title',
		alert_logged_out_message: 'alert_logged_out_message',
		alert_delete_account_title: 'alert_delete_account_title',
		alert_delete_account_message: 'alert_delete_account_message',
		alert_delete_account_confirm: 'alert_delete_account_confirm',
		alert_delete_account_final_title: 'alert_delete_account_final_title',
		alert_delete_account_final_message: 'alert_delete_account_final_message',
		alert_account_deleted_title: 'alert_account_deleted_title',
		alert_account_deleted_message: 'alert_account_deleted_message',
		alert_delete_event_title: 'alert_delete_event_title',
		alert_delete_event_message: 'alert_delete_event_message',
		alert_unsubscribe_title: 'alert_unsubscribe_title',
		alert_unsubscribe_message: 'alert_unsubscribe_message',
		alert_new_notification: 'alert_new_notification',
		text_have_account: 'text_have_account',
		text_no_account: 'text_no_account',
		text_register_link: 'text_register_link',
		// Days
		day_sunday: 'day_sunday',
		day_monday: 'day_monday',
		day_tuesday: 'day_tuesday',
		day_wednesday: 'day_wednesday',
		day_thursday: 'day_thursday',
		day_friday: 'day_friday',
		day_saturday: 'day_saturday',
		day_unknown: 'day_unknown',
		// Extras
		title_news: 'title_news',
		title_choose_gallery: 'title_choose_gallery',
		text_choose_gallery_description: 'text_choose_gallery_description',
		text_no_favorites_for_day: 'text_no_favorites_for_day',
		text_no_activities_in_timetable: 'text_no_activities_in_timetable',
		text_no_gallery_data: 'text_no_gallery_data',
		text_extra_information: 'text_extra_information',
		text_no_results_found: 'text_no_results_found',
		// Empty states
		text_no_news_title: 'text_no_news_title',
		text_no_news_message: 'text_no_news_message',
		text_no_food_title: 'text_no_food_title',
		text_no_food_message: 'text_no_food_message',
		text_no_locations_title: 'text_no_locations_title',
		text_no_locations_message: 'text_no_locations_message',
		text_no_program_title: 'text_no_program_title',
		text_no_program_message: 'text_no_program_message',
		text_no_timetable_title: 'text_no_timetable_title',
		text_no_timetable_message: 'text_no_timetable_message',
		text_no_galleries_title: 'text_no_galleries_title',
		text_no_galleries_message: 'text_no_galleries_message',
		text_no_content_title: 'text_no_content_title',
		text_no_content_message: 'text_no_content_message',
		text_no_map_title: 'text_no_map_title',
		text_no_map_message: 'text_no_map_message',
		text_error_prefix: 'text_error_prefix',
		button_back: 'button_back',
		// My submission (Mijn aanmelding)
		my_submission_banner_title: 'my_submission_banner_title',
		my_submission_banner_subtitle: 'my_submission_banner_subtitle',
		my_submission_helper: 'my_submission_helper',
		my_submission_registration_label: 'my_submission_registration_label',
		my_submission_programme_title: 'my_submission_programme_title',
		my_submission_empty_title: 'my_submission_empty_title',
		my_submission_empty_message: 'my_submission_empty_message',
		my_submission_error_title: 'my_submission_error_title',
		my_submission_error_message: 'my_submission_error_message',
		// On behalf (Aanmelden voor iemand anders)
		on_behalf_question: 'on_behalf_question',
		on_behalf_self: 'on_behalf_self',
		on_behalf_other: 'on_behalf_other',
		on_behalf_logged_in_as: 'on_behalf_logged_in_as',
		on_behalf_email_hint: 'on_behalf_email_hint',
		on_behalf_success_message: 'on_behalf_success_message',
		on_behalf_list_title: 'on_behalf_list_title',
		on_behalf_cancel_message: 'on_behalf_cancel_message',
		on_behalf_cancelled_message: 'on_behalf_cancelled_message',
	} as const;

	// App
	public static get appName() {
		return t(this.keys.app_name);
	}

	// App update dialog
	public static get update() {
		return t(this.keys.update);
	}
	public static get updateLater() {
		return t(this.keys.update_later);
	}
	public static get updateAvailable() {
		return t(this.keys.update_available);
	}
	public static get updateAvailableDescription() {
		return t(this.keys.update_available_description);
	}
	public static get updateAvailableMandatory() {
		return t(this.keys.update_available_mandatory);
	}
	public static get updateAvailableMandatoryDescription() {
		return t(this.keys.update_available_mandatory_description);
	}
	public static updateAvailableVersionText({
		currentVersion,
		newVersion,
	}: {
		currentVersion: string;
		newVersion: string;
	}) {
		return t(this.keys.update_available_version_text, { currentVersion, newVersion });
	}

	// Archive
	public static get archiveDefaultTitle() {
		return t(this.keys.archive_default_title);
	}
	public static get archiveEmptyMessage() {
		return t(this.keys.archive_empty_message);
	}
	public static get archiveSearchPlaceholder() {
		return t(this.keys.archive_search_placeholder);
	}
	public static get archiveRecentEvents() {
		return t(this.keys.archive_recent_events);
	}
	public static get archiveOtherEvents() {
		return t(this.keys.archive_other_events);
	}

	// Messages
	public static get messageDefaultTitle() {
		return t(this.keys.message_default_title);
	}
	public static get messageEmptyMessage() {
		return t(this.keys.message_empty_message);
	}
	public static get messageWebOnlyTitle() {
		return t(this.keys.message_web_only_title);
	}
	public static get messageWebOnlyMessage() {
		return t(this.keys.message_web_only_message);
	}
	public static get qrWebOnlyTitle() {
		return t(this.keys.qr_web_only_title);
	}
	public static get qrWebOnlyMessage() {
		return t(this.keys.qr_web_only_message);
	}
	public static get messageSearchPlaceholder() {
		return t(this.keys.message_search_placeholder);
	}
	public static get messageNoResultsTitle() {
		return t(this.keys.message_no_results_title);
	}
	public static get messageNoResults() {
		return t(this.keys.message_no_results);
	}

	// Errors
	public static get errorDefaultSubject() {
		return t(this.keys.error_default_subject);
	}
	public static get errorDefaultMessage() {
		return t(this.keys.error_default_message);
	}
	public static get noticeSessionNotStoredTitle() {
		return t(this.keys.notice_session_not_stored_title);
	}
	public static get noticeSessionNotStoredEmbedded() {
		return t(this.keys.notice_session_not_stored_embedded);
	}
	public static get noticeSessionNotStored() {
		return t(this.keys.notice_session_not_stored);
	}
	public static get errorSessionExpiredTitle() {
		return t(this.keys.error_session_expired_title);
	}
	public static get errorSessionExpired() {
		return t(this.keys.error_session_expired);
	}
	public static get errorTryAgain() {
		return t(this.keys.error_try_again);
	}
	public static get errorFetchEvent() {
		return t(this.keys.error_fetch_event);
	}
	public static get errorSaveEvent() {
		return t(this.keys.error_save_event);
	}
	public static get errorDeleteEvent() {
		return t(this.keys.error_delete_event);
	}
	public static get errorAddEvent() {
		return t(this.keys.error_add_event);
	}
	public static get errorEventInList() {
		return t(this.keys.error_event_in_list);
	}
	public static get errorEmptyEmailSubject() {
		return t(this.keys.error_empty_email_subject);
	}
	public static get errorEmptyEmailMessage() {
		return t(this.keys.error_empty_email_message);
	}
	public static get errorUserNotFoundSubject() {
		return t(this.keys.error_user_not_found_subject);
	}
	public static get errorUserNotFoundMessage() {
		return t(this.keys.error_user_not_found_message);
	}
	public static get errorInvalidCredentials() {
		return t(this.keys.error_invalid_credentials);
	}
	public static get errorCameraPermission() {
		return t(this.keys.error_camera_permission);
	}
	public static get errorCameraRollPermissionIos() {
		return t(this.keys.error_camera_roll_permission_ios);
	}
	public static get errorCameraRollPermissionAndroid() {
		return t(this.keys.error_camera_roll_permission_android);
	}
	public static get errorDeleteEventOffline() {
		return t(this.keys.error_delete_event_offline);
	}
	public static get errorAddEventOffline() {
		return t(this.keys.error_add_event_offline);
	}
	public static get errorAddEventFailed() {
		return t(this.keys.error_add_event_failed);
	}
	public static get errorEventNotFoundTitle() {
		return t(this.keys.error_event_not_found_title);
	}
	public static get errorEventNotFoundMessage() {
		return t(this.keys.error_event_not_found_message);
	}
	public static get errorFavoriteToggleFailed() {
		return t(this.keys.error_favorite_toggle_failed);
	}
	public static get errorFavoritesLoadFailed() {
		return t(this.keys.error_favorites_load_failed);
	}
	public static get errorFavoritesUnavailableTitle() {
		return t(this.keys.error_favorites_unavailable_title);
	}
	public static get errorFavoritesRefresh() {
		return t(this.keys.error_favorites_refresh);
	}
	public static get errorEmptyEventCode() {
		return t(this.keys.error_empty_event_code);
	}
	public static get errorSomethingWentWrong() {
		return t(this.keys.error_something_went_wrong);
	}
	/** The server refused because too many requests came from this device. */
	public static get errorTooManyAttempts() {
		return t(Translations.keys.error_too_many_attempts);
	}

	public static get errorTryAgainLater() {
		return t(this.keys.error_try_again_later);
	}
	public static get cancelDeadlinePassedTitle() {
		return t(this.keys.cancel_deadline_passed_title);
	}
	public static get cancelDeadlinePassedMessage() {
		return t(this.keys.cancel_deadline_passed_message);
	}
	public static get errorSomethingWentWrongShort() {
		return t(this.keys.error_something_went_wrong_short);
	}
	public static get errorSomethingWentWrongGeneric() {
		return t(this.keys.error_something_went_wrong_generic);
	}
	public static get errorNoConnection() {
		return t(this.keys.error_no_connection);
	}
	public static get errorServer() {
		return t(this.keys.error_server);
	}
	public static get errorWentWrongTitle() {
		return t(this.keys.error_went_wrong_title);
	}
	public static get errorReturnToHome() {
		return t(this.keys.error_return_to_home);
	}
	public static get errorPasswordTooShortTitle() {
		return t(this.keys.error_password_too_short_title);
	}
	public static get errorPasswordTooShortMessage() {
		return t(this.keys.error_password_too_short_message);
	}
	public static get errorPasswordsNotMatchingTitle() {
		return t(this.keys.error_passwords_not_matching_title);
	}
	public static get errorPasswordsNotMatchingMessage() {
		return t(this.keys.error_passwords_not_matching_message);
	}
	public static get errorPasswordsNotMatchingInline() {
		return t(this.keys.error_passwords_not_matching_inline);
	}
	public static get errorInvalidEmailInline() {
		return t(this.keys.error_invalid_email_inline);
	}
	public static get errorFeedbackMissingTitle() {
		return t(this.keys.error_feedback_missing_title);
	}
	public static get errorFeedbackMissingMessage() {
		return t(this.keys.error_feedback_missing_message);
	}
	public static get errorEmptyForm() {
		return t(this.keys.error_empty_form);
	}
	public static get errorRequiredFields() {
		return t(this.keys.error_required_fields);
	}
	public static get errorFillFieldAbove() {
		return t(this.keys.error_fill_field_above);
	}
	public static get errorFieldRequired() {
		return t(this.keys.error_field_required);
	}
	public static get errorEventFullTitle() {
		return t(this.keys.error_event_full_title);
	}
	public static get errorEventFullMessage() {
		return t(this.keys.error_event_full_message);
	}
	public static get errorFormClosedTitle() {
		return t(this.keys.error_form_closed_title);
	}
	public static get errorFormClosedMessage() {
		return t(this.keys.error_form_closed_message);
	}
	public static get errorFormContactNote() {
		return t(this.keys.error_form_contact_note);
	}
	public static get errorFormLoginRequired() {
		return t(this.keys.error_form_login_required);
	}
	public static get errorFormNeedsConnection() {
		return t(this.keys.error_form_needs_connection);
	}
	public static get errorFormLoadFailed() {
		return t(this.keys.error_form_load_failed);
	}
	public static get errorLoginRequiredForEvent() {
		return t(this.keys.error_login_required_for_event);
	}
	public static get errorEmailExistsTitle() {
		return t(this.keys.error_email_exists_title);
	}
	public static get errorEmailExistsMessage() {
		return t(this.keys.error_email_exists_message);
	}
	public static get errorFetchGallery() {
		return t(this.keys.error_fetch_gallery);
	}
	public static get errorPhotoPermissionTitle() {
		return t(this.keys.error_photo_permission_title);
	}
	public static get errorPhotoPermissionMessage() {
		return t(this.keys.error_photo_permission_message);
	}
	public static get errorCameraNotAvailableTitle() {
		return t(this.keys.error_camera_not_available_title);
	}
	public static get errorCameraNotAvailableMessage() {
		return t(this.keys.error_camera_not_available_message);
	}
	public static get errorImageLoad() {
		return t(this.keys.error_image_load);
	}
	public static get errorLinkOpenTitle() {
		return t(this.keys.error_link_open_title);
	}
	public static get errorLinkOpenMessage() {
		return t(this.keys.error_link_open_message);
	}
	public static get errorOpenPhoneTitle() {
		return t(this.keys.error_open_phone_title);
	}
	public static get errorOpenEmailTitle() {
		return t(this.keys.error_open_email_title);
	}
	public static get errorOpenLinkTitle() {
		return t(this.keys.error_open_link_title);
	}
	public static errorOpenValueMessage(value: string) {
		return t(this.keys.error_open_value_message, { value });
	}

	// Success
	public static get successSavedSubject() {
		return t(this.keys.success_saved_subject);
	}
	public static get successPhotoSaved() {
		return t(this.keys.success_photo_saved);
	}
	public static get successRegisterSubject() {
		return t(this.keys.success_register_subject);
	}
	public static get successRegisterMessage() {
		return t(this.keys.success_register_message);
	}
	public static get successLoginSubject() {
		return t(this.keys.success_login_subject);
	}
	public static get successLoginMessage() {
		return t(this.keys.success_login_message);
	}
	public static get successWelcomeDefault() {
		return t(this.keys.success_welcome_default);
	}
	public static successWelcomeNamed(name: string) {
		return t(this.keys.success_welcome_named, { name });
	}
	public static get successEditProfileSubject() {
		return t(this.keys.success_edit_profile_subject);
	}
	public static get successEditProfileMessage() {
		return t(this.keys.success_edit_profile_message);
	}
	public static get successPasswordResetSubject() {
		return t(this.keys.success_password_reset_subject);
	}
	public static get successPasswordResetMessage() {
		return t(this.keys.success_password_reset_message);
	}
	public static get successPasswordForgotSubject() {
		return t(this.keys.success_password_forgot_subject);
	}
	public static get successPasswordForgotMessage() {
		return t(this.keys.success_password_forgot_message);
	}
	public static get successUploadedTitle() {
		return t(this.keys.success_uploaded_title);
	}
	public static get successUploadedMessage() {
		return t(this.keys.success_uploaded_message);
	}
	public static get successFeedbackTitle() {
		return t(this.keys.success_feedback_title);
	}
	public static get successFeedbackMessage() {
		return t(this.keys.success_feedback_message);
	}
	public static get successFormReceivedTitle() {
		return t(this.keys.success_form_received_title);
	}
	public static get successFormReceivedMessage() {
		return t(this.keys.success_form_received_message);
	}
	public static get successUnsubscribedTitle() {
		return t(this.keys.success_unsubscribed_title);
	}
	public static get successUnsubscribedMessage() {
		return t(this.keys.success_unsubscribed_message);
	}
	public static get successPasswordChanged() {
		return t(this.keys.success_password_changed);
	}
	public static get successDownloadedTitle() {
		return t(this.keys.success_downloaded_title);
	}
	public static get successDownloadedMessageIos() {
		return t(this.keys.success_downloaded_message_ios);
	}
	public static get successDownloadedMessageAndroid() {
		return t(this.keys.success_downloaded_message_android);
	}
	public static get successDownloadedMessageWeb() {
		return t(this.keys.success_downloaded_message_web);
	}

	// Labels
	public static get labelFirstName() {
		return t(this.keys.label_first_name);
	}
	public static get labelLastName() {
		return t(this.keys.label_last_name);
	}
	public static get labelEmail() {
		return t(this.keys.label_email);
	}
	public static get labelEmailAndroid() {
		return t(this.keys.label_email_android);
	}
	public static get labelPassword() {
		return t(this.keys.label_password);
	}
	public static get labelPasswordRepeat() {
		return t(this.keys.label_password_repeat);
	}
	public static get labelNewPassword() {
		return t(this.keys.label_new_password);
	}
	public static get labelNewPasswordRepeat() {
		return t(this.keys.label_new_password_repeat);
	}
	public static get labelYourName() {
		return t(this.keys.label_your_name);
	}
	public static get labelTheFeedback() {
		return t(this.keys.label_the_feedback);
	}
	public static get labelVideoPlayer() {
		return t(this.keys.label_video_player);
	}
	public static get labelMap() {
		return t(this.keys.label_map);
	}

	// Placeholders
	public static get placeholderFirstName() {
		return t(this.keys.placeholder_first_name);
	}
	public static get placeholderFirstNameShort() {
		return t(this.keys.placeholder_first_name_short);
	}
	public static get placeholderLastName() {
		return t(this.keys.placeholder_last_name);
	}
	public static get placeholderLastNameShort() {
		return t(this.keys.placeholder_last_name_short);
	}
	public static get placeholderEmail() {
		return t(this.keys.placeholder_email);
	}
	public static get placeholderEmailShort() {
		return t(this.keys.placeholder_email_short);
	}
	public static get placeholderEmailAndroid() {
		return t(this.keys.placeholder_email_android);
	}
	public static get placeholderPassword() {
		return t(this.keys.placeholder_password);
	}
	public static get placeholderPasswordMinChars() {
		return t(this.keys.placeholder_password_min_chars);
	}
	public static get placeholderPasswordRepeat() {
		return t(this.keys.placeholder_password_repeat);
	}
	public static get placeholderPasswordShort() {
		return t(this.keys.placeholder_password_short);
	}
	public static get placeholderPasswordRepeatShort() {
		return t(this.keys.placeholder_password_repeat_short);
	}
	public static get placeholderYourName() {
		return t(this.keys.placeholder_your_name);
	}
	public static get placeholderFeedback() {
		return t(this.keys.placeholder_feedback);
	}
	public static get placeholderFeedbackShort() {
		return t(this.keys.placeholder_feedback_short);
	}
	public static get placeholderChooseOption() {
		return t(this.keys.placeholder_choose_option);
	}
	public static get placeholderSearch() {
		return t(this.keys.placeholder_search);
	}
	public static get placeholderEventCode() {
		return t(this.keys.placeholder_event_code);
	}

	// Buttons
	public static get buttonLogin() {
		return t(this.keys.button_login);
	}
	public static get buttonRegister() {
		return t(this.keys.button_register);
	}
	public static get buttonRegisterLower() {
		return t(this.keys.button_register_lower);
	}
	public static get buttonSave() {
		return t(this.keys.button_save);
	}
	public static get buttonSubmit() {
		return t(this.keys.button_submit);
	}
	public static get buttonChangePassword() {
		return t(this.keys.button_change_password);
	}
	public static get buttonForgotPassword() {
		return t(this.keys.button_forgot_password);
	}
	public static get buttonMaybeLater() {
		return t(this.keys.button_maybe_later);
	}
	public static get buttonSendEmail() {
		return t(this.keys.button_send_email);
	}
	public static get buttonCancel() {
		return t(this.keys.button_cancel);
	}
	public static get buttonContinue() {
		return t(this.keys.button_continue);
	}
	public static get buttonOpen() {
		return t(this.keys.button_open);
	}

	public static get labelChoiceInfo() {
		return t(Translations.keys.label_choice_info);
	}
	public static get buttonViewProgramPart() {
		return t(Translations.keys.button_view_program_part);
	}
	public static get buttonFavorite() {
		return t(Translations.keys.button_favorite);
	}
	public static get buttonProgramViewList() {
		return t(Translations.keys.button_program_view_list);
	}
	public static get buttonProgramViewBlocks() {
		return t(Translations.keys.button_program_view_blocks);
	}

	public static get textChoiceFull() {
		return t(Translations.keys.text_choice_full);
	}

	/** "3 / 10 deelnemers", shown when the beheerder asked for the tally. */
	public static textParticipantsOf(taken: number, limit: number) {
		return t(Translations.keys.text_participants_of, { taken, limit });
	}

	/** Heading when a choice cannot be ticked. */
	public static get textChoiceNotPossible() {
		return t(Translations.keys.text_choice_not_possible);
	}

	/** The question already has as many choices as it may have. */
	public static textMaxChoices(count: number) {
		return t(Translations.keys.text_max_choices, { count });
	}

	/** The day already has as many choices as it may have. */
	public static textDayFull(day: string, count: number) {
		return t(Translations.keys.text_day_full, { day, count });
	}

	/** This choice runs at the same time as one that is already ticked. */
	public static textOverlaps(other: string) {
		return t(Translations.keys.text_overlaps, { other });
	}

	/** Seats left on a choice; plural handled by i18next's count. */
	public static textSeatsLeft(count: number) {
		return t(Translations.keys.text_seats_left, { count });
	}
	public static get mapsOpenTitle() {
		return t(this.keys.maps_open_title);
	}
	public static get mapsOpenMessage() {
		return t(this.keys.maps_open_message);
	}
	public static get mapsChooseMessage() {
		return t(this.keys.maps_choose_message);
	}
	public static get buttonOk() {
		return t(this.keys.button_ok);
	}
	public static get buttonOke() {
		return t(this.keys.button_oke);
	}
	public static get buttonCopy() {
		return t(this.keys.button_copy);
	}
	public static get buttonSaveChanges() {
		return t(this.keys.button_save_changes);
	}
	public static get buttonSubmitUpper() {
		return t(this.keys.button_submit_upper);
	}
	public static get buttonCancelUpper() {
		return t(this.keys.button_cancel_upper);
	}
	public static get buttonAddUpper() {
		return t(this.keys.button_add_upper);
	}
	public static get buttonNavigateLocationUpper() {
		return t(this.keys.button_navigate_location_upper);
	}
	public static get buttonAdd() {
		return t(this.keys.button_add);
	}
	public static get buttonDeleteUpper() {
		return t(this.keys.button_delete_upper);
	}
	public static get buttonCancelDeleteUpper() {
		return t(this.keys.button_cancel_delete_upper);
	}
	public static get buttonDelete() {
		return t(this.keys.button_delete);
	}
	public static get buttonClose() {
		return t(this.keys.button_close);
	}
	public static get buttonEdit() {
		return t(this.keys.button_edit);
	}
	public static get buttonDone() {
		return t(this.keys.button_done);
	}
	public static get titleSubscribe() {
		return t(this.keys.title_subscribe);
	}

	// Tabs
	public static get tabHome() {
		return t(this.keys.tab_home);
	}
	public static get tabArchive() {
		return t(this.keys.tab_archive);
	}
	public static get tabMessages() {
		return t(this.keys.tab_messages);
	}
	public static get tabPhotos() {
		return t(this.keys.tab_photos);
	}
	public static get tabSettings() {
		return t(this.keys.tab_settings);
	}

	// Page titles
	public static get titleSettings() {
		return t(this.keys.title_settings);
	}
	public static get titleLoginOrRegister() {
		return t(this.keys.title_login_or_register);
	}
	public static get titleWelcome() {
		return t(this.keys.title_welcome);
	}
	public static get titleFeedback() {
		return t(this.keys.title_feedback);
	}
	public static get titleContact() {
		return t(this.keys.title_contact);
	}
	public static get titleProfile() {
		return t(this.keys.title_profile);
	}
	public static get titleEditProfile() {
		return t(this.keys.title_edit_profile);
	}
	public static get titleForgotPassword() {
		return t(this.keys.title_forgot_password);
	}
	public static get titleChangePassword() {
		return t(this.keys.title_change_password);
	}
	public static get titleRegister() {
		return t(this.keys.title_register);
	}
	public static get titleQrScanner() {
		return t(this.keys.title_qr_scanner);
	}
	public static get titlePhotos() {
		return t(this.keys.title_photos);
	}
	public static get titleFormClosed() {
		return t(this.keys.title_form_closed);
	}
	public static get titleMyTimetable() {
		return t(this.keys.title_my_timetable);
	}
	public static get titleMySubmission() {
		return t(this.keys.title_my_submission);
	}
	public static get titlePrograms() {
		return t(this.keys.title_programs);
	}
	/** "Dag 2", for a heading that names a day of a programme that runs several. */
	public static titleDayNumber(number: number) {
		return t(this.keys.title_day_number, { number });
	}

	// Texts
	public static get textLoginDescription() {
		return t(this.keys.text_login_description);
	}
	public static get textChangePasswordDescription() {
		return t(this.keys.text_change_password_description);
	}
	public static get textEmailNotEditable() {
		return t(this.keys.text_email_not_editable);
	}
	public static get textEmailFromAccount() {
		return t(this.keys.text_email_from_account);
	}
	public static get textNoInternet() {
		return t(this.keys.text_no_internet);
	}
	public static get textScanQrInstruction() {
		return t(this.keys.text_scan_qr_instruction);
	}
	public static get textFormLoginDescription() {
		return t(this.keys.text_form_login_description);
	}
	public static get textForgotPasswordDescription() {
		return t(this.keys.text_forgot_password_description);
	}
	public static get textHomeHasEvents() {
		return t(this.keys.text_home_has_events);
	}
	public static get textHomeNoEvents() {
		return t(this.keys.text_home_no_events);
	}
	public static get textAddEvent() {
		return t(this.keys.text_add_event);
	}
	public static get textNoPhotosTitle() {
		return t(this.keys.text_no_photos_title);
	}
	public static get textNoPhotosMessage() {
		return t(this.keys.text_no_photos_message);
	}
	public static get textGalleryEmpty() {
		return t(this.keys.text_gallery_empty);
	}
	public static get textFeedbackHelper() {
		return t(this.keys.text_feedback_helper);
	}
	public static get textProfileSubtitle() {
		return t(this.keys.text_profile_subtitle);
	}
	public static get textReceiveNotifications() {
		return t(this.keys.text_receive_notifications);
	}
	public static get textReceiveNotificationsHelper() {
		return t(this.keys.text_receive_notifications_helper);
	}
	public static get textGiveFeedback() {
		return t(this.keys.text_give_feedback);
	}
	public static get textVersionNumber() {
		return t(this.keys.text_version_number);
	}
	public static get textPrivacyPolicy() {
		return t(this.keys.text_privacy_policy);
	}
	public static get urlPrivacyPolicy() {
		return t(this.keys.url_privacy_policy);
	}
	public static get urlTopicus() {
		return t(this.keys.url_topicus);
	}
	public static get textContactTopicus() {
		return t(this.keys.text_contact_topicus);
	}
	public static get textContactAddress() {
		return t(this.keys.text_contact_address);
	}
	public static get textContactPostal() {
		return t(this.keys.text_contact_postal);
	}
	public static get textSetProfilePhoto() {
		return t(this.keys.text_set_profile_photo);
	}
	public static get textChooseProfilePhoto() {
		return t(this.keys.text_choose_profile_photo);
	}
	public static get textUploadPhoto() {
		return t(this.keys.text_upload_photo);
	}
	public static get textGalleries() {
		return t(this.keys.text_galleries);
	}
	public static get textHinderedQuestion() {
		return t(this.keys.text_hindered_question);
	}
	public static get textUnsubscribe() {
		return t(this.keys.text_unsubscribe);
	}
	public static get textDeleteAccount() {
		return t(this.keys.text_delete_account);
	}

	// Alerts
	public static get alertAccessEventTitle() {
		return t(this.keys.alert_access_event_title);
	}
	public static get alertAccessEventMessage() {
		return t(this.keys.alert_access_event_message);
	}
	public static get alertLoginRequiredTitle() {
		return t(this.keys.alert_login_required_title);
	}
	public static get alertLoginRequiredMessage() {
		return t(this.keys.alert_login_required_message);
	}
	public static get alertLoginRequiredViewMessage() {
		return t(this.keys.alert_login_required_view_message);
	}
	public static get alertEventAlreadyAddedTitle() {
		return t(this.keys.alert_event_already_added_title);
	}
	public static get alertScanQr() {
		return t(this.keys.alert_scan_qr);
	}
	public static get alertEnterCode() {
		return t(this.keys.alert_enter_code);
	}
	public static get alertEventCodeTitle() {
		return t(this.keys.alert_event_code_title);
	}
	public static get alertEventCodeMessage() {
		return t(this.keys.alert_event_code_message);
	}
	public static get alertAddEventTitle() {
		return t(this.keys.alert_add_event_title);
	}
	public static get alertAddEventDescription() {
		return t(this.keys.alert_add_event_description);
	}
	public static get alertAddEventConfirmMessage() {
		return t(this.keys.alert_add_event_confirm_message);
	}
	public static get alertAddPhotoTitle() {
		return t(this.keys.alert_add_photo_title);
	}
	public static get alertAddPhotoMessage() {
		return t(this.keys.alert_add_photo_message);
	}
	public static get alertOpenCamera() {
		return t(this.keys.alert_open_camera);
	}
	public static get alertOpenCameraRoll() {
		return t(this.keys.alert_open_camera_roll);
	}
	public static get alertLogoutTitle() {
		return t(this.keys.alert_logout_title);
	}
	public static get alertLogoutMessage() {
		return t(this.keys.alert_logout_message);
	}
	public static get alertLoggedOutTitle() {
		return t(this.keys.alert_logged_out_title);
	}
	public static get alertLoggedOutMessage() {
		return t(this.keys.alert_logged_out_message);
	}
	public static get alertDeleteAccountTitle() {
		return t(this.keys.alert_delete_account_title);
	}
	public static get alertDeleteAccountMessage() {
		return t(this.keys.alert_delete_account_message);
	}
	public static get alertDeleteAccountConfirm() {
		return t(this.keys.alert_delete_account_confirm);
	}
	public static get alertDeleteAccountFinalTitle() {
		return t(this.keys.alert_delete_account_final_title);
	}
	public static get alertDeleteAccountFinalMessage() {
		return t(this.keys.alert_delete_account_final_message);
	}
	public static get alertAccountDeletedTitle() {
		return t(this.keys.alert_account_deleted_title);
	}
	public static get alertAccountDeletedMessage() {
		return t(this.keys.alert_account_deleted_message);
	}
	public static get alertDeleteEventTitle() {
		return t(this.keys.alert_delete_event_title);
	}
	public static get alertDeleteEventMessage() {
		return t(this.keys.alert_delete_event_message);
	}
	public static get alertUnsubscribeTitle() {
		return t(this.keys.alert_unsubscribe_title);
	}
	public static get alertUnsubscribeMessage() {
		return t(this.keys.alert_unsubscribe_message);
	}
	public static get alertNewNotification() {
		return t(this.keys.alert_new_notification);
	}
	public static get textHaveAccount() {
		return t(this.keys.text_have_account);
	}
	public static get textNoAccount() {
		return t(this.keys.text_no_account);
	}
	public static get textRegisterLink() {
		return t(this.keys.text_register_link);
	}

	// Days
	public static get daySunday() {
		return t(this.keys.day_sunday);
	}
	public static get dayMonday() {
		return t(this.keys.day_monday);
	}
	public static get dayTuesday() {
		return t(this.keys.day_tuesday);
	}
	public static get dayWednesday() {
		return t(this.keys.day_wednesday);
	}
	public static get dayThursday() {
		return t(this.keys.day_thursday);
	}
	public static get dayFriday() {
		return t(this.keys.day_friday);
	}
	public static get daySaturday() {
		return t(this.keys.day_saturday);
	}
	public static get dayUnknown() {
		return t(this.keys.day_unknown);
	}
	public static get days() {
		return [
			this.daySunday,
			this.dayMonday,
			this.dayTuesday,
			this.dayWednesday,
			this.dayThursday,
			this.dayFriday,
			this.daySaturday,
		];
	}

	// Extras
	public static get titleNews() {
		return t(this.keys.title_news);
	}
	public static get titleChooseGallery() {
		return t(this.keys.title_choose_gallery);
	}
	public static get textChooseGalleryDescription() {
		return t(this.keys.text_choose_gallery_description);
	}
	public static get textNoFavoritesForDay() {
		return t(this.keys.text_no_favorites_for_day);
	}
	public static get textNoActivitiesInTimetable() {
		return t(this.keys.text_no_activities_in_timetable);
	}
	public static get textNoGalleryData() {
		return t(this.keys.text_no_gallery_data);
	}
	public static get textExtraInformation() {
		return t(this.keys.text_extra_information);
	}
	public static get textNoResultsFound() {
		return t(this.keys.text_no_results_found);
	}

	// Empty states
	public static get textNoNewsTitle() {
		return t(this.keys.text_no_news_title);
	}
	public static get textNoNewsMessage() {
		return t(this.keys.text_no_news_message);
	}
	public static get textNoFoodTitle() {
		return t(this.keys.text_no_food_title);
	}
	public static get textNoFoodMessage() {
		return t(this.keys.text_no_food_message);
	}
	public static get textNoLocationsTitle() {
		return t(this.keys.text_no_locations_title);
	}
	public static get textNoLocationsMessage() {
		return t(this.keys.text_no_locations_message);
	}
	public static get textNoProgramTitle() {
		return t(this.keys.text_no_program_title);
	}
	public static get textNoProgramMessage() {
		return t(this.keys.text_no_program_message);
	}
	public static get textNoTimetableTitle() {
		return t(this.keys.text_no_timetable_title);
	}
	public static get textNoTimetableMessage() {
		return t(this.keys.text_no_timetable_message);
	}
	public static get textNoGalleriesTitle() {
		return t(this.keys.text_no_galleries_title);
	}
	public static get textNoGalleriesMessage() {
		return t(this.keys.text_no_galleries_message);
	}
	public static get textNoContentTitle() {
		return t(this.keys.text_no_content_title);
	}
	public static get textNoContentMessage() {
		return t(this.keys.text_no_content_message);
	}
	public static get textNoMapTitle() {
		return t(this.keys.text_no_map_title);
	}
	public static get textNoMapMessage() {
		return t(this.keys.text_no_map_message);
	}
	public static get textErrorPrefix() {
		return t(this.keys.text_error_prefix);
	}
	public static get buttonBack() {
		return t(this.keys.button_back);
	}

	// My submission (Mijn aanmelding)
	public static get mySubmissionBannerTitle() {
		return t(this.keys.my_submission_banner_title);
	}
	public static get mySubmissionBannerSubtitle() {
		return t(this.keys.my_submission_banner_subtitle);
	}
	public static get mySubmissionHelper() {
		return t(this.keys.my_submission_helper);
	}
	public static get mySubmissionRegistrationLabel() {
		return t(this.keys.my_submission_registration_label);
	}
	public static get mySubmissionProgrammeTitle() {
		return t(this.keys.my_submission_programme_title);
	}
	public static get mySubmissionEmptyTitle() {
		return t(this.keys.my_submission_empty_title);
	}
	public static get mySubmissionEmptyMessage() {
		return t(this.keys.my_submission_empty_message);
	}
	public static get mySubmissionErrorTitle() {
		return t(this.keys.my_submission_error_title);
	}
	public static get mySubmissionErrorMessage() {
		return t(this.keys.my_submission_error_message);
	}

	// On behalf (Aanmelden voor iemand anders)
	public static get onBehalfQuestion() {
		return t(this.keys.on_behalf_question);
	}
	public static get onBehalfSelf() {
		return t(this.keys.on_behalf_self);
	}
	public static get onBehalfOther() {
		return t(this.keys.on_behalf_other);
	}
	public static onBehalfLoggedInAs({ name, email }: { name: string; email: string }) {
		return t(this.keys.on_behalf_logged_in_as, { name, email });
	}
	public static get onBehalfEmailHint() {
		return t(this.keys.on_behalf_email_hint);
	}
	public static onBehalfSuccessMessage({ email }: { email: string }) {
		return t(this.keys.on_behalf_success_message, { email });
	}
	public static get onBehalfListTitle() {
		return t(this.keys.on_behalf_list_title);
	}
	public static onBehalfCancelMessage({ name }: { name: string }) {
		return t(this.keys.on_behalf_cancel_message, { name });
	}
	public static onBehalfCancelledMessage({ name }: { name: string }) {
		return t(this.keys.on_behalf_cancelled_message, { name });
	}
}

export default Translations;
